import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import OrderForm from './component/orders/OrderForm';
import Login from './component/orders/login/login';
import HomeBackend from './component/HomeBackend';
import OrgDetails from './component/orders/OrgDetails';
import LoadingAnimation from './component/LoadingAnimation';
import PrivateRoute from './component/PrivateRoute'; // Import PrivateRoute

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/loding" element={<LoadingAnimation />} />
     
        <Route
          path="/orders/:itemId"
          element={
            <OrderForm/>
          }
        />
        <Route
          path="/orders"
          element={
            <OrderForm
 
            />
          }
        />
        <Route
          path="/home"
          element={
            <PrivateRoute
              element={HomeBackend}
            />
          }
        />
        <Route
          path="/org-details"
          element={<PrivateRoute element={OrgDetails} />}
        />
      </Routes>
    </div>
  );
}

export default App;
